export default function getAnimation(fileName: string, format?: string) {
  return `/jsons/${fileName}.${format ?? "json"}`;
}
